module.exports = __webpack_public_path__ + "static/fonts/feather.5fad700.eot";


//////////////////
// WEBPACK FOOTER
// ./src/package/theme/fonts/feather.eot
// module id = gGY4
// module chunks = 5